module.exports = "/_next/static/images/2b969e28446a0e3d35b17a2ed33be491-cajita-nu.png.webp";